module.exports = __webpack_public_path__ + "img/安藤周人.466a2443.png";